import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";
import { guestRequestConfig } from "./guestToken";

export const createPatient = createAsyncThunk(
  "create_patient",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/patients/`,
        params,
        config
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const getPatientDetails = createAsyncThunk(
  "get_patient_details",
  async (params, { rejectWithValue, getState }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${params.id}/`,
        guestRequestConfig(getState())
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data, {
          status: error?.response?.status,
        });
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const getPatientShippingAddresses = createAsyncThunk(
  "get_patient_shiping_address",
  async (params, { rejectWithValue, getState }) => {
    try {
      const { id } = params;
      const data = await axiosClient.get(
        `${config.API_URL}/patients/${id}/shipping_addresses/`,
        guestRequestConfig(getState())
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data, {
          status: error?.response?.status,
        });
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const postPatientShippingAddress = createAsyncThunk(
  "post_patient_shiping_address",
  async (params, { rejectWithValue, getState }) => {
    const { id, ...rest } = params;
    try {
      const data = await axiosClient.post(
        `${config.API_URL}/patients/${id}/shipping_addresses/`,
        rest,
        guestRequestConfig(getState())
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const patchPatientShippingAddress = createAsyncThunk(
  "patch_patient_shiping_address",
  async (params, { rejectWithValue, getState }) => {
    const { id, addressId, ...restparams } = params;
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/patients/${id}/shipping_addresses/${addressId}/`,
        restparams,
        guestRequestConfig(getState())
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);

export const patchPatient = createAsyncThunk(
  "patch_patient",
  async (params, { rejectWithValue, getState }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL}/patients/${params.id}/`,
        params,
        guestRequestConfig(getState())
      );
      return data;
    } catch (error) {
      if (
        error?.response &&
        error?.response?.data &&
        typeof error?.response?.data === "object"
      ) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue({
          Error: error?.message,
        });
      }
    }
  }
);
